import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { isArray } from 'rxjs/internal-compatibility';
import { DeleteFileComponent } from 'src/app/components/dialog/files/delete-file/delete-file.component';
import { FileToCategoryComponent } from 'src/app/components/dialog/files/file-to-category/file-to-category.component';
import { UploadFileWithDateComponent } from 'src/app/components/dialog/files/upload-file-with-date/upload-file-with-date.component';
import { ViewFileDataComponent } from 'src/app/components/dialog/files/view-file-data/view-file-data.component';
import { FILE_STATES } from 'src/app/constants/files/file-states';
import { ACTIONS_FILES_LIST } from 'src/app/constants/files/files-list-actions';
import { PaginationInput, PaginationPageEvent, ListParams, Res, File, FileData } from 'src/app/models';
import { FileterConditions } from 'src/app/models/filter-conditions.model';
import { LanguageService, ApiOrganizationsService, FilesService, DialogModalService, PermissionService, DatetimeService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { ApiSettingsService } from 'src/app/services/api-settings.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { SortDirection } from '../../attributes/attributes-list/attributes-list.component';
// export type SortDirection = 'asc' | 'desc' | '';

export type Direction = 'asc' | 'desc' | '';
@Component({
  selector: 'app-files-list',
  templateUrl: './files-list.component.html',
  styleUrls: ['./files-list.component.css']
})


export class FilesListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  files: File[] = [];
  searchFiles: File[] = [];
  usageSpace: any;
  storage: any;
  amount: any;
  countSelectedFiles: number = 0;
  selectedFiles: any[] = [];
  currentOrganization: any;
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  btnUploadFilesMultiple: boolean = true;
  maxUsageSpace: any;
  categoryType: string = 'files_categories';
  fileLink: string;
  hiddenCategory: boolean;
  hiddenFilter: boolean;
  allIds: string[] = [];

  //Фильтрация продуктов
  filter: any;
  selectedOperatorsForCondition: string = 'AND';
  condition = {
    [this.selectedOperatorsForCondition]: []
  };
  filterConditionData: FileterConditions[] = [];
  filterCategoryStatus: boolean = false;
  categoriesIds: string[] = [];
  categoryCondition = {
    attribute_id: "6e218c45-a642-48ab-86e7-5c0af242819b",
    operator: "contains",
    value: []
  };

  //Сортировака данных продукта
  collapsed = true;
  sort: any[] = [];
  direction: Direction = 'asc';
  headerDirection: any[] = [];
  columnDirection: string;

  actionsList = ACTIONS_FILES_LIST;
  fileData: FileData = null;


  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiFileService: FilesService,
    private apiOrganizations: ApiOrganizationsService,
    private dialogModal: DialogModalService,
    private apiSettings: ApiSettingsService,
    public permissionAccess: PermissionService,
    private router: Router,
    private apiBasic: ApiBasicService,
    private paginationService: PaginationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.currentOrganization = this.apiOrganizations.currentOrganization;
    this.maxUsageSpace = this.apiSettings.getSettingValues('STORAGE_MAX_SIZE');

    if(this.permissionAccess.check('FILE_CATEGORY_REFERENCE')){

      // this.setStateCategoryBox();
    }

    this.subscriptions.add(
      this.apiSettings.listenerSettings().subscribe(val => {

        if (val) {

          this.maxUsageSpace = this.apiSettings.getSettingValues('STORAGE_MAX_SIZE');

        }
      })
    );

    if (this.currentOrganization) {

      if (this.permissionAccess.check('GET_ORG_TOTAL_USAGE_SPACE')) {

        this.getUsageSpace();
      }

      this.getList();
    }

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrganization = val;
        this.getUsageSpace();
        this.getList();
      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(
      this.apiFileService.listenerFilterData().subscribe(val => {

        if (val) {

          console.log("FILTER DATA: ", val);

          // setTimeout(()=>this.applyFilterData('global', val), 600) 
          this.applyFilterData(val, 'global');

        }

      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  * @param attr_name 
  * @param columnName 
  */
  sortData(name: string) {

    const rotate: { [key: string]: Direction } = { 'asc': 'desc', 'desc': '', '': 'asc' };

    let index = this.sort.findIndex(val => val.sortBy == name);

    if (index > -1 && this.sort[index].sortBy == name) {

      this.headerDirection[index].direction = rotate[this.headerDirection[index].direction];

      this.sort[index].direction = this.headerDirection[index].direction;

    }
    else {

      let directionObj = {
        direction: this.direction
      }

      this.headerDirection.push(directionObj);

      let sortObj = {
        sortBy: name,
        direction: this.direction
      }

      this.sort.push(sortObj);
    }

    // this.getList(this.form.value.filters);
    this.getList();
  }

  /**
   * 
   * @param attr_id 
   * @returns 
   */
  checkDirection(attr_id) {

    let columnDirection = this.sort.find(val => val.sortBy == attr_id);

    return columnDirection != null ? columnDirection.direction : null;

  }


  /**
   * 
   */
  getUsageSpace() {

    this.apiFileService.getUsageSpace(this.currentOrganization.id).subscribe((response: Res) => {
      console.log('[RESPONSE] Files getUsageSpace', response);

      if (response != null) {

        this.usageSpace = (response.result.total_usage_space / 1024 / 1024 / 1024).toFixed(2);
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }


  /**
   * 
   * @param fileName string
   * @returns string
   */
  checkIconExt(fileName: string): string {

    return this.apiFileService.checkIconExt(fileName);
  }


  /**
   * 
   */
  getList(type: string = ''): void {

    this.progressRef.start();
    this.loading = true;
    this.countSelectedFiles = 0;
    this.files = [];

    this.setListParams();

    this.apiFileService.getList(this.listParams).subscribe((response: any) => {
      // this.apiBasic.getList(this.listParams, 'orgs_files').subscribe((response: Res) => {
      console.log('[RESPONSE] Files list: ', response)

      if (response) {

        if (response != null && response.result != null) {

          if (type == 'global') {

            this.searchFiles = response.result.list;
            this.apiFileService.setFileListData(this.searchFiles);

          } else {

            this.files = response.result.list;
          }

          this.amount = response.result.count;

          this.storage = (this.usageSpace * 100) / this.maxUsageSpace;

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }

          this.paginationService.setPaginationData(this.paginationInput);
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.filter = {
      condition: this.selectedOperatorsForCondition,
      sort: [],
      categories_id: this.categoriesIds,
      attribute: this.filterConditionData
    }

    this.listParams = {

      filter: this.filter,
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   */
  uploadFile() {

    let data = {
      organizationId: this.apiOrganizations.currentOrganization.id,
      option: {
        multiple: true,
        component: 'files'
      }
    }

    this.dialogModal.open(data, UploadFileWithDateComponent, '', 'upload-file-window').then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   * @param index 
   * @param image 
   */
  getImageContent(file_id: any): void {

    this.fileLink = null

    this.subscriptions.add(

      this.apiFileService.getImageContent(file_id).subscribe((response: any) => {

        if (response != null) {

          this.fileLink = response.result;

        }
      })
    );
  }

  /**
   * 
   */
  eventCategoryList(item: any) {

    console.log("EVENT: ", item);

    if (item.checked) {

      this.categoriesIds.push(item.id);

    }
    else {

      let index = this.categoriesIds.findIndex(val => val == item.id);

      if (index > -1) {

        this.categoriesIds.splice(index, 1);

      }

    }

    this.getList();

  }

  openWindowWithButton(pop:any)
  {
    pop.open()
  }


  eventCloseCategory(event) {

    console.log("EVENT", event);
    
    this.hiddenCategory = event;
  }

  eventCloseFilter(event) {

    console.log("EVENT", event);
    
    this.hiddenFilter = event;
  }

  // /**
  // * 
  // */
  toggleCategoryBox(): void {

    this.filterCategoryStatus = !this.filterCategoryStatus;
    this.setStateCategoryBoxInLocalStorage();
  }


  /**
   * 
   */
  setStateCategoryBoxInLocalStorage(): void {

    localStorage.setItem('state_file_category_box', this.filterCategoryStatus ? '1' : '0');
  }


  // /**
  //  * 
  //  */
  // setStateCategoryBox(): void {

  //   let state: string = localStorage.getItem('state_file_category_box');

  //   if (state) {

  //     this.filterCategoryStatus = state == '1' ? true : false;
  //     return;
  //   }

  //   this.setStateCategoryBoxInLocalStorage();
  // }


  /**
   * 
   * @param fileId 
   */
  onDelete(fileId: string) {

    let data = {
      id: isArray(fileId) ? fileId : [fileId]
    }

    this.dialogModal.open(data, DeleteFileComponent).then(
      (result) => {

        if (result) {

          // this.onDelete(ids);
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   * @param ids 
   */
  // onDelete(ids: string[]): void {

  //   this.progressRef.start();

  //   this.subscriptions.add(
  //     this.apiFileService.delete({ id: ids }).subscribe(response => {

  //       if (response != null) {

  //         this.getList();

  //         this.notification.show('success', 'Данные успешно удалены!');
  //       }

  //       this.progressRef.complete();
  //     })
  //   );
  // }

  /**
   * DOWNLOAD FILE
   * @param file
   */
  downloadFile(fileId: string, fileName: string): void {

    console.log("ID: ", fileId, "NAME: ", fileName);


    this.apiFileService.downloadFile(fileName, fileId);
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.countSelectedFiles = 0;
    this.paginationOutput = event;
    this.getList();
  }


  /**
   * 
   */
  getProfile(fileId: string) {

    let data = {
      file_id: fileId
    }

    this.dialogModal.open(data, ViewFileDataComponent, '', 'profile-file-window').then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * 
  */
  addFileToCategory(file_id: string, categorie_id: string) {

    let data = {

      // file_ids: [...new Set(this.files.filter(val => val.checked).map(({ id }) => id))]
      file_ids: [file_id],
      category_id: categorie_id
    }

    this.dialogModal.open(data, FileToCategoryComponent).then(
      (result) => {

        if (result) {

          this.getList();
          this.getFileInfo(file_id);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  //FILTER 
  /**
   * 
   */
  applyFilterData(data: any, type: string = '') {

    console.log("DATA: ", data);

    // Обнуляем счетчик
    this.countSelectedFiles = 0
    // Обнуляем пагинацию(сбрасываем на дефолтное значение)
    this.paginationOutput = null;

    this.selectedOperatorsForCondition = data.operatorForContion ? data.operatorForContion : 'AND';


    this.filterConditionData = type == 'global' ? [data] : data.form.filters;

    this.getList(type);

  }


  /**
   * 
   */
  resetFilter() {

    // Обнуляем пагинацию(сбрасываем на дефолтное значение)
    this.paginationOutput = null;
    // Обнуляем счетчик
    this.countSelectedFiles = 0
    // Обнуляем значение фильтра
    this.filterConditionData = [];
    this.categoriesIds = [];
    // Обнуляем условие оператор фильтрации
    // this.condition[this.selectedOperatorsForCondition] = [];

    this.getList();
  }

  // CHECKBOX
  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.files[index].checked = event.target.checked;
    this.counterSelectedFiles();
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    let fc = this.files.filter(val => val.checked).length;

    this.files.forEach(x => fc > 0 ? x.checked = false : x.checked = event.target.checked);

    this.counterSelectedFiles();

    this.storageForChekcedFiles();
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.files.length == 0) return false;

    return this.files.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.files.length;
    let pc = this.files.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.files.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

  /**
   * 
   */
  chooseAllFiles() {

    this.subscriptions.add(

      this.apiBasic.getAlListIds('files', this.listParams).subscribe((response: Res) => {
        console.log("[RESPONSE] getAllProducts/ID: ", response);

        if (response != null) {

          this.allIds = response.result;

          this.files.forEach(x => x.checked = true);

          this.countSelectedFiles = this.amount;

        }

        this.loading = false;
      },
        error => {
          this.loading = false;
        })

    );

  }

  /**
   * 
   */
  unChooseAllFiles() {

    this.files.forEach(x => x.checked = false);
    this.allIds = [];
    this.countSelectedFiles = 0;
  }

  /**
   * 
   */
  counterSelectedFiles() {

    this.countSelectedFiles = this.files.filter(val => val.checked).length;

  }

  /**
   * 
   */
  storageForChekcedFiles() {

    // this.files.forEach((x, i) => x.checked ? this.selectedFiles.push(x) : this.selectedFiles.splice(i, 1));

    this.files.findIndex(i => i.checked);

    console.log("SELECTED FILES: ", this.files);
    console.log("SELECTED FILES: ", this.selectedFiles);
  }

  /**
   * 
   * @param file
   */
  getFileInfo(id: string): void {

    this.fileData = null;
    this.loading = true;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.getFileInfo(id).subscribe(response => {
        console.log("[RESPONSE] getFileInfo: ", response);

        if (response != null) {

          this.fileData = response.result;

          this.getImageContent(id);

          if (this.fileData.link) {

            // this.fileData.link = this.fileData.link.substring(26);
          }
        }

        this.loading = false;
        this.progressRef.complete();
      })
    );
  }

  /**
 * 
 * @param size number
 * @returns string
 */
  convertationToMb(size: number): string {

    let convertData: number;
    let dataType: string = "kb";

    convertData = size / 1024;

    if (convertData > 1024) {
      convertData = convertData / 1024;
      dataType = "mb"
    }

    return convertData.toFixed(2) + " " + dataType;
  }

  /**
   * 
   * @param stateId 
   * @returns 
   */
  translateState(stateId: string): string {

    let fileState: any = FILE_STATES.find(val => val.id == stateId);

    return fileState != undefined ? fileState.name : 'Статус не определен';

  }

  checkState(state:string){

    return state == 'EXPIRED' ? true : false; 
  }

  /**
   * 
   */
  //  toggleSidebar(s: boolean = null): void {

  //   this.status = (s == null) ? !this.status : s;
  //   this.setStateSidebarInLocalStorage();
  // }

  // /**
  //  * 
  //  */
  //  setStateSidebarInLocalStorage(): void {

  //   localStorage.setItem('state_tree_sidebar', this.status ? '1' : '0'); 
  // }


  // /**
  //  * 
  //  */
  // setStateSidebar(): void {

  //   let stateSidebar: string = localStorage.getItem('state_tree_sidebar');

  //   if(stateSidebar){

  //     this.status = stateSidebar == '1' ? true : false;
  //     return;
  //   }

  //   this.status = false;
  //   this.setStateSidebarInLocalStorage();
  // }

  onEdit(id: string) {

    this.router.navigate(['files', 'edit', id]);

  }
}
